import { CommunitiesProps } from "../providers/types";

const CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours for Communities as they rarely change

interface CommunitiesCache {
  data: CommunitiesProps[];
  cachedAt: number;
}

export const readCommunitiesCache = (key: string): CommunitiesProps[] | null => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { data, cachedAt } = JSON.parse(raw) as CommunitiesCache;
    return Array.isArray(data) && Date.now() - cachedAt < CACHE_TTL_MS ? data : null;
  } catch {
    return null;
  }
};

export const writeCommunitiesCache = (key: string, data: CommunitiesProps[]) => {
  try {
    localStorage.setItem(key, JSON.stringify({ data, cachedAt: Date.now() } satisfies CommunitiesCache));
  } catch {
    // ignore e.g. storage quota errors
  }
};